import { BAHN_RADIUS, GERADE_HALB, MITTE_X, MITTE_Y, STUETZE_D, STUETZEN_GERADE_X, STUETZEN_WINKEL_GRAD } from './masse.js';
/**
 * Die zwanzig Baumstuetzen des Daches als gesperrte Kacheln in den hinteren
 * Reihen des Oberrings: acht auf den Geraden, zwoelf in den Kurven. Beim
 * Vorbild stehen sie genau dort — im Rang, nicht draussen — und sind der
 * Grund fuer die Plaetze mit Sichtbehinderung. Die Winkel liegen zwischen
 * den Oberring-Treppen und neben den Tunneln. Karte und Optik kennen
 * dieselben Orte: das Theme baut die Stuetze dort, wo die Karte sie sperrt.
 */
function stuetzenKacheln() {
    const kacheln = new Set();
    const radius = BAHN_RADIUS + STUETZE_D + 0.5;
    const setze = (px, py) => {
        kacheln.add(`${Math.floor(px)}:${Math.floor(py)}`);
    };
    for (const dx of STUETZEN_GERADE_X) {
        for (const vorzeichen of [1, -1]) {
            setze(MITTE_X + vorzeichen * dx + 0.5, MITTE_Y - radius);
            setze(MITTE_X + vorzeichen * dx + 0.5, MITTE_Y + radius);
        }
    }
    for (const grad of STUETZEN_WINKEL_GRAD) {
        for (const vorzeichen of [1, -1]) {
            const w = (vorzeichen * grad * Math.PI) / 180;
            setze(MITTE_X + GERADE_HALB + Math.cos(w) * radius, MITTE_Y + Math.sin(w) * radius);
            setze(MITTE_X - GERADE_HALB - Math.cos(w) * radius, MITTE_Y + Math.sin(w) * radius);
        }
    }
    return kacheln;
}
const STUETZEN = stuetzenKacheln();
export function istStuetze(x, y) {
    return STUETZEN.has(`${x}:${y}`);
}
export const STUETZEN_ANZAHL = STUETZEN.size;
//# sourceMappingURL=stuetzen.js.map